import { Button, Divider, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import CustomAddCountryInput from '../../../../Components/CustomInputLogin/CustomAddCountryInput';
import * as Yup from "yup";
import CustoDropDownRegister from '../../../../Components/CustomDropDown/CustoDropDownRegister';
import CustomUserRegisterDropdown from '../../../../Components/CustomDropDown/CustomUserRegisterDropdown';
import { useDispatch } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';

const KycAdd = ({ onClose }) => {
    const [inputValue, setInputValue] = useState("");
    const [localValues, setLocalValues] = useState([]);


    const [countryNames, setCountryNames] = useState([]);
    const [selectedCountryId, setSelectedCountryId] = useState(null);


    const dispatch = useDispatch()

    useEffect(() => {
        const fetchCountries = async () => {
            const data = {
                data: {},
                method: "get",
                apiName: "getAllCountryNames",
            };

            const responseData = await dispatch(actions.GETALLCOUNTRYNAMES(data));

            if (responseData?.payload?.message === "Countries retrieved successfully.") {
                const formattedCountries =
                    responseData?.payload?.data?.map((country) => ({
                        label: country.country_name,
                        value: country.country_name,
                        id: country.country_id, // Store country ID
                    })) || [];

                setCountryNames(formattedCountries);
            }
        };

        fetchCountries();

    }, [])

    const handleCountryChange = async (selectedValue, selectedId, values) => {
        console.log("Selected Country:", selectedValue);
        console.log("Selected Country ID:", selectedId);

        if (selectedId) {
            setSelectedCountryId(selectedId);
        }
    };

    const handleSubmit =async (values) => {
        const data1 = {
            data: {
                country_id: selectedCountryId,
                kycs: values?.kyc
            },
            method: "post",
            apiName: `addMultipleKYCs`
        };
        const responseData = await dispatch(actions.ADDMULTIPLEKYCS(data1))

        // handleSubmit(values)
        console.log(values, "valuessssss")
        if (responseData?.payload?.message === "KYCs added successfully.") {
            // console.log(values, "valuessssss");
            setInputValue("");
            setLocalValues([]);
            // setTabValue(3)
            onClose()
        } else {
            toast.error(responseData?.payload?.message)
        }

    }


    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{
                    country: "",
                    kyc: []
                }}
                validationSchema={Yup.object({
                    country: Yup.string().required("Country is required"),

                    kyc: Yup.array().min(1, "At least one country is required"),
                })}
                // onSubmit={(values, { setFieldValue }) => {
                //     if (inputValue.trim() !== "") {
                //         values.state = [...values.state]; // Include the last typed value
                //     }

                //     console.log(values, "valuessssss")
                //     setInputValue("")
                //     setLocalValues([])
                // }}
                onSubmit={(values, { setFieldValue }) => {
                    if (inputValue.trim() !== "") {
                        setFieldValue("kyc", [...values.kyc, inputValue]); // Add inputValue to state array
                    }
                 handleSubmit(values)
                    // console.log(values, "valuessssss");
                    // setInputValue("");
                    // setLocalValues([]);
                    // onClose()
                }}
            >
                {({ handleSubmit, setFieldValue, resetForm, values }) => (
                    <Form onSubmit={handleSubmit}>
                        {/* <DialogContent dividers> */}
                        <Grid container spacing={2} mb={4}>
                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <CustomUserRegisterDropdown
                                            name="country"
                                            label="Country"
                                            custPlaceholder="Select Country"
                                            options={countryNames}
                                            // options={[
                                            //     { label: "Individual", value: "Individual" },
                                            //     { label: "Institutional", value: "Institutional" },
                                            // ]}
                                            onChange={handleCountryChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                        <CustomAddCountryInput
                                            label="Document Type"
                                            name="kyc"
                                            inputType="text"
                                            custPlaceholder="Enter Document Type"
                                            setFieldValue={setFieldValue}
                                            values={values.country}
                                            inputValue={inputValue} // Pass inputValue
                                            setInputValue={setInputValue} //
                                            localValues={localValues}
                                            setLocalValues={setLocalValues}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider />


                        <Grid sx={{ display: "flex", justifyContent: "end", mt: 1 }}>
                            <Grid>
                                <Button
                                    onClick={() => {
                                        resetForm();
                                        // setUploadedFiles(null);
                                        // onClose()
                                        // dispatch(clearCustomerId(null))
                                        // dispatch(clearTableGetId(null))


                                    }}
                                    variant="text"
                                    // className="custom-clear-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        mr: "10px",
                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "white",
                                        boxShadow: "none",
                                        color: "black",
                                        border: "1px solid black",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            color: "white",
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    // className="custom-ok-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        boxShadow: "none",

                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "#C38F51 0% 0% no-repeat padding-box",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            boxShadow: "none",
                                        },
                                    }}
                                >
                                    {/* {customerId ? "Update" : "Submit"} */}

                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                        {/* </DialogContent> */}

                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default KycAdd